module.exports = __webpack_public_path__ + "static/media/map.c3bf40ba.png";